const Authorization = () => {
    return (
        <>
         auth
        </>
    )
}

export default Authorization;